import React from 'react';

/**
 * Render markdown bold (**text**) as <strong> elements.
 * Preserves whitespace and newlines when used inside an element with
 * `whiteSpace: 'pre-wrap'`.
 *
 * Tiny custom parser instead of a full markdown library — we only need bold,
 * and JSX <strong> is safe by construction (no raw HTML insertion).
 *
 * Algorithm: split on (** ... **) capturing groups so the bold markers stay
 * in the array. Each captured chunk that matches **...** becomes <strong>;
 * everything else stays as a plain string fragment.
 */
export function renderMarkdownBold(content) {
  if (!content) return null;
  const parts = content.split(/(\*\*[^*]+?\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
}
